module.exports = __webpack_public_path__ + "img/kid-item5.68497077.png";